const historyCheckRouter = [
    {
        path: 'list-leakage',
        name: 'list-leakage',
        component: () => import('@/views/admin/history_check/index.vue'), // Ensure correct component is imported
        meta: {
            model: 'history_check',
            requiresAuth: true,
        }
    }
];

export default historyCheckRouter;